/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Question_0Inputs */

const en_help_center__account_n_technical__question_0 = /** @type {(inputs: Help_Center__Account_N_Technical__Question_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I reset my password?`)
};

/**
* | output |
* | --- |
* | "How do I reset my password?" |
*
* @param {Help_Center__Account_N_Technical__Question_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__question_0 = /** @type {((inputs?: Help_Center__Account_N_Technical__Question_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Question_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__question_0(inputs)
});